import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';
import {SelectDefaultTemplateDialogComponent} from '@features/oic/components/select-default-template-dialog/select-default-template-dialog.component';
import {PauseResumeOicWorkflowDialogComponent} from '@features/oic/components/pause-resume-oic-workflow-dialog/pause-resume-oic-workflow-dialog.component';
import {PeopleAndRolesDialogueComponent} from '@features/oic/components/people-and-roles-dialogue/people-and-roles-dialogue.component';

export class OicDynamicComponentHelper {
  public static components: any;

  public static init() {
    if (OicDynamicComponentHelper.components) {
      return;
    }
    const components = {};
    components['SelectDefaultTemplateDialogComponent'] = SelectDefaultTemplateDialogComponent;
    components['PauseResumeOicWorkflowDialogComponent'] = PauseResumeOicWorkflowDialogComponent;
    components['PeopleAndRolesDialogueComponent'] = PeopleAndRolesDialogueComponent;
    OicDynamicComponentHelper.components = components;
    RootDynamicComponentHelper.merge(components);
  }

  public static register(key: string, component: any) {
    OicDynamicComponentHelper.components[key] = component;
    RootDynamicComponentHelper.register(key, component);
  }
}
